import { c as _c } from "react/compiler-runtime";
import { JpgIcon } from './JpgIcon';
import { PdfIcon } from './PdfIcon';
import { PngIcon } from './PngIcon';
import { XlslIcon } from './XlslIcon';
type FileIconProps = {
  type?: string;
};
export const FileIcon = t0 => {
  const $ = _c(4);
  const {
    type
  } = t0;
  if (type === "image/png") {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PngIcon />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (type === "application/pdf") {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <PdfIcon />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" || type === "application/vnd.ms-excel") {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <XlslIcon />;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    return t1;
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <JpgIcon />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};